import fdc from './fdc/ko.js'

export default {
  fdc
}
